// extracted by mini-css-extract-plugin
export default {"messageContent":"MessageCard_messageContent__3CqlU","title":"MessageCard_title__rJ86p","text":"MessageCard_text__C7AVk"};